<template>
  <div style="display: flex; align-items: center;">
    <b-pagination 
      first-number 
      last-number 
      :per-page="perPage" 
      :size="size" 
      :value="value" 
      :align="align" 
      :total-rows="total"
      :limit="limit"
      :ellipsis-text="ellipsisText"
      @change="(val) => $emit('change', val)"
    >
      <template v-slot:prev-text>
        <a class="page-link" aria-label="Previous">
          <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
        </a>
      </template>
      <template v-slot:next-text>
        <a class="page-link" aria-label="Next">
          <span aria-hidden="true"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        </a>
      </template>
    </b-pagination>
    <div class="ml-3 per-page-dropdown">
      <div class="per-page-selected" @click="showDropdown = !showDropdown">
        {{ perPage }}
        <span class="per-page-arrow">▼</span>
      </div>
      <div v-if="showDropdown" class="per-page-options">
        <div
          v-for="option in perPageOptions"
          :key="option"
          class="per-page-option"
          :class="{ active: perPage == option }"
          @click="selectPerPage(option); showDropdown = false;"
        >
          {{ option }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BasePagination',
  props: {
    pageCount: {
      type: Number,
      default: 0,
      description:
        'Pagination page count. This should be specified in combination with perPage',
    },
    perPage: {
      type: Number,
      default: 10,
      description:
        'Pagination per page. Should be specified with total or pageCount',
    },
    total: {
      type: Number,
      default: 0,
      description:
        'Can be specified instead of pageCount. The page count in this case will be total/perPage',
    },
    value: {
      type: Number,
      default: 1,
      description: 'Pagination value',
    },
    size: {
      type: String,
      default: '',
      description: 'Pagination size',
    },
    align: {
      type: String,
      default: '',
      description: 'Pagination alignment (e.g center|start|end)',
    },
    limit: {
      type: Number,
      default: 5,
      description: 'Maximum number of page buttons to show (excluding first/last and ellipsis)',
    },
    ellipsisText: {
      type: String,
      default: '…',
      description: 'Text to show for ellipsis',
    },
  },
  data() {
    return {
      perPageOptions: [10, 20, 50, 100],
      showDropdown: false,
    };
  },
  methods: {
    selectPerPage(option) {
      const value = String(option);
      this.$emit('update:perPage', value);
      this.$emit('input', value);
      this.$emit('change', 1); 
    },
  },
};
 </script>
<style scoped lang="scss">


/* Hace el menú y los ítems lo más pequeños posible */


.per-page-select {
  padding: 0 32px 0 16px;
  font-size: 14px;
  height: 38px;
  border-radius: 4px;
  border: 1px solid $primary;
  background: $primary;
}

.per-page-dropdown {
  position: relative;
  display: inline-block;
}
.per-page-selected {
  padding: 0 16px;
  font-size: 14px;
  height: 38px;
  border-radius: 4px;
  border: 1px solid $primary;
  background: $primary;
  color: #fff;
  min-width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 500;
  user-select: none;
}
.per-page-arrow {
  margin-left: 6px;
  font-size: 12px;
}
.per-page-options {
  position: absolute;
  bottom: 100%;
  left: 0;
  min-width: 100%;
  background: #fff;
  border: 1px solid $primary;
  border-radius: 4px;
  box-shadow: 0 -2px 8px rgba($primary, 0.08);
  z-index: 10;
}
.per-page-option {
  padding: 4px 0;
  text-align: center;
  font-size: 14px;
  color: $primary;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.per-page-option:hover,
.per-page-option.active {
  background: $primary;
  color: #fff;
}

</style>
